import { render, staticRenderFns } from "./BBResendedConciliations.vue?vue&type=template&id=6bc6c582&lang=pug"
import script from "./BBResendedConciliations.vue?vue&type=script&lang=js"
export * from "./BBResendedConciliations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports